module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', [_c('loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [(_vm.errorMessage) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v("\n        " + _vm._s(_vm.errorMessage) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("\n        Cadastro realizado com sucesso. \n        "), _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Clique aqui para realizar o login")])], 1) : _vm._e(), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Meus Dados")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.name),
      expression: "user.name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "email",
      "type": "email",
      "placeholder": "Ex: maria@barreiros.ifpe.edu.br"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmEmail),
      expression: "confirmEmail"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "emailConf",
      "type": "email"
    },
    domProps: {
      "value": (_vm.confirmEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmEmail = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmPassword),
      expression: "confirmPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "passwordConf",
      "type": "password"
    },
    domProps: {
      "value": (_vm.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmPassword = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.signup
    }
  }, [_vm._v("Cadastrar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Voltar")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Nome Completo "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" (de preferência o institucional)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Confirmar Email "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Senha "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Confirmar Senha "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9989ed26"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Signup.vue
// module id = 1464
// module chunks = 1